import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const submitWebForm = async (payload: any) => {
    let url = `${NGROK}/api/websites/weburl-request-access`;
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });

    return data;
};